import { BlocksIconMoneySend } from 'blocks-nextjs/blocks-web-components/components/icon/icons/money-send';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconMoneySend = createComponent({ react: React, tagName: 'cat-icon-money-send', elementClass: BlocksIconMoneySend });
